import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from './constants';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  return <a href={CHECKOUT_URL} className={`inline-flex w-full items-center justify-center gap-2 rounded-sm border-b-4 border-goldDark bg-gold px-3 py-3 text-center font-display text-xl leading-none tracking-wide text-navy shadow-lg transition hover:bg-[#d8b45e] focus:outline-none focus:ring-4 focus:ring-gold/35 active:translate-y-0.5 active:border-b-2 sm:text-2xl ${className}`} data-id="element-34" data-mp="2kwlgjpq9dfp1">
      <span data-id="element-35" data-mp="33r8sf78p0do2">{children}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-36" data-mp="2yqcpox02uxk8" />
    </a>;
}